/**
 * Wishlist Button Component
 */

import { useWishlist, useAuth, useShop } from '@/context';
import styles from './WishlistButton.module.css';

interface WishlistButtonProps {
  productId: number;
  size?: 'small' | 'medium' | 'large';
  showLabel?: boolean;
}

export function WishlistButton({
  productId,
  size = 'medium',
  showLabel = false,
}: WishlistButtonProps) {
  const { isInWishlist, toggleItem, isLoading } = useWishlist();
  const { isLoggedIn } = useAuth();
  const { t } = useShop();

  const isActive = isInWishlist(productId);

  const handleClick = async () => {
    if (!isLoggedIn) {
      window.location.href = window.evcShop.urls.login;
      return;
    }

    try {
      await toggleItem(productId);
    } catch {
      // Error handled in context
    }
  };

  const label = isActive ? t('removeFromWishlist') : t('addToWishlist');

  return (
    <button
      className={`${styles.button} ${styles[size]} ${isActive ? styles.active : ''}`}
      onClick={handleClick}
      disabled={isLoading}
      aria-label={label}
      title={label}
    >
      <HeartIcon filled={isActive} />
      {showLabel && <span className={styles.label}>{label}</span>}
    </button>
  );
}

interface HeartIconProps {
  filled: boolean;
}

function HeartIcon({ filled }: HeartIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="2"
      className={styles.icon}
    >
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  );
}
